const escapeHtml = (value = "") => String(value)
  .replaceAll("&", "&amp;")
  .replaceAll("<", "&lt;")
  .replaceAll(">", "&gt;")
  .replaceAll('"', "&quot;")
  .replaceAll("'", "&#039;");

const safeColor = (value, fallback) => /^#[0-9a-f]{6}$/i.test(value || "") ? value : fallback;

const safeHttpUrl = (value = "") => {
  try {
    const url = new URL(value);
    return ["http:", "https:"].includes(url.protocol) ? url.toString() : "";
  } catch {
    return "";
  }
};

export const blockedPageDefaults = {
  template: "plain",
  title: "Access blocked",
  message: "This request has been blocked by our security policy.",
  show_contact_line: true,
  contact_text: "If you believe this is an error, contact your administrator.",
  button_label: "",
  button_url: "",
  background_color: "#090d16",
  text_color: "#f8fafc",
  accent_color: "#06b6d4",
  logo_url: "",
};

const templateStyles = (config) => {
  const background = safeColor(config.background_color, blockedPageDefaults.background_color);
  const text = safeColor(config.text_color, blockedPageDefaults.text_color);
  const accent = safeColor(config.accent_color, blockedPageDefaults.accent_color);
  if (config.template === "branded") {
    return {
      body: `background:${background};color:${text}`,
      panel: `background:rgba(15,23,42,.72);border:1px solid ${accent}55;box-shadow:0 28px 80px rgba(0,0,0,.32)`,
      accent,
      muted: text,
    };
  }
  if (config.template === "maintenance") {
    return {
      body: "background:#f3f6fb;color:#182338",
      panel: "background:#ffffff;border:1px solid #dbe3ef;box-shadow:0 24px 70px rgba(30,41,59,.12)",
      accent: "#f59e0b",
      muted: "#64748b",
    };
  }
  return {
    body: "background:#ffffff;color:#202b3c",
    panel: "background:#ffffff;border:0;box-shadow:none",
    accent: "#ef476f",
    muted: "#6b7280",
  };
};

export const buildBlockedPagePreviewHtml = (value = {}) => {
  const config = { ...blockedPageDefaults, ...value };
  const styles = templateStyles(config);
  const logo = safeHttpUrl(config.logo_url);
  const buttonUrl = safeHttpUrl(config.button_url);
  const icon = config.template === "maintenance" ? "↻" : "×";
  const logoHtml = config.template === "branded" && logo
    ? `<img src="${escapeHtml(logo)}" alt="" referrerpolicy="no-referrer">`
    : `<div class="status-icon" aria-hidden="true">${icon}</div>`;
  const contactHtml = config.show_contact_line && config.contact_text
    ? `<p class="contact">${escapeHtml(config.contact_text)}</p>`
    : "";
  const buttonHtml = buttonUrl && config.button_label
    ? `<a class="action" href="${escapeHtml(buttonUrl)}">${escapeHtml(config.button_label)}</a>`
    : "";

  return `<!doctype html><html lang="en"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style>
    *{box-sizing:border-box} body{margin:0;min-height:100vh;display:grid;place-items:center;padding:28px;${styles.body};font-family:Inter,Segoe UI,Arial,sans-serif}
    .panel{width:min(620px,100%);text-align:center;padding:clamp(34px,8vw,68px);border-radius:10px;${styles.panel}}
    .visual{width:70px;height:70px;margin:0 auto 24px;display:grid;place-items:center}.visual img{max-width:100%;max-height:100%;object-fit:contain}
    .status-icon{width:58px;height:58px;border-radius:50%;display:grid;place-items:center;background:${styles.accent}18;color:${styles.accent};border:1px solid ${styles.accent}44;font-size:34px;line-height:1;font-weight:300}
    h1{margin:0 0 14px;font-size:clamp(27px,6vw,42px);font-weight:700;line-height:1.12;letter-spacing:0}p{margin:0 auto;max-width:500px;line-height:1.65;color:${styles.muted};opacity:.88;white-space:pre-line;font-size:15px}
    .contact{margin-top:20px;font-size:13px;opacity:.72}.action{display:inline-flex;margin-top:26px;padding:11px 20px;border-radius:6px;background:${styles.accent};color:#fff;text-decoration:none;font-weight:700}
  </style></head><body><main class="panel"><div class="visual">${logoHtml}</div><h1>${escapeHtml(config.title)}</h1><p>${escapeHtml(config.message)}</p>${contactHtml}${buttonHtml}</main></body></html>`;
};